import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import _ from 'lodash';
import * as moment from 'moment';

import { saveAs } from 'file-saver';
import { Subscription } from 'rxjs';
import { AdminService } from '../../admin.service';
import { NotificationMessageService } from '../../../shared/notification-message/notification-message.service';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../../auth/user.service';

@Component({
	selector: 'app-smart-rebates-sites',
	templateUrl: './smart_rebates_sites.component.html',
	styleUrls: ['./smart_rebates_sites.component.css']
})
export class SmartRebatesSitesComponent implements OnInit {
	@ViewChild("consumptionsReportDialog") consumptionsReportDialog: any;
	downloadConsumptionsReportSubscription!: Subscription;
	selectedYear: number = new Date().getFullYear();
	selectedSiteId: number = 0;
	selectedStartDate: any;

	quarters = [
		{id: 0, value: 'All Year'},
		{id: 1, value:'Q1'},
		{id: 2, value:'Q2'},
		{id: 3, value:'Q3'},
		{id: 4, value:'Q4'}
	];

	selectedQuarter = this.quarters[0].id;
	years = [];
	private RSDataTimer: any;
	isPolling: boolean = false;
	siteName: string = "";

	data: any[] = [];
	constructor(
		private router: Router,
		private adminService: AdminService,
		private notificationMessage: NotificationMessageService,
		public translate: TranslateService,
		private userService: UserService,
	) { }

	ngOnInit() {
		if (!(this.userService.hasAccessFunction('official_reporting')))
			return this.router.navigate(['/unauthorized']);

		return this.getSmartRebatesSitesInfo();
	}

	ngAfterViewInit() {
		this.consumptionsReportDialog.onClose.subscribe((result: any) => {
			if (result) {
				this.downloadConsumptionsReport(false);
			}
		});

		this.consumptionsReportDialog.onExtra.subscribe((result: any) => {
			if (result) {
				this.downloadConsumptionsReport(true);
			}
		});
	}

	getSmartRebatesSitesInfo() {
		this.adminService.getSmartRebatesSitesInfo().subscribe((data: any) => {
			this.data = data;
		})
	}

	showConsumptionsReport(site: any) {
		if(this.RSDataTimer){
			return this.notificationMessage.setMessage('You currently have a report processing, please wait.');
		}
		this.selectedSiteId = site.id;
		const startDate = new Date(site.installation_date);
		this.siteName = site.name || "";
		this.getAllYearsFromDate(startDate);
		this.consumptionsReportDialog.show();
	}

	getAllYearsFromDate(startDate) {
		if (!startDate)
			return

		const currentDate = new Date();
		const startYear = startDate.getFullYear();
		const currentYear = currentDate.getFullYear();
		const years = [];

		for (let year = startYear; year <= currentYear; year++) {
				years.push(year);
		}

		if (!years.length)
			years.push(currentYear);

		this.selectedYear = years[years.length -1];
		this.years = years;
	}

	downloadConsumptionsReport(regenerateFile= false) {
		let selectedStartDate = this.selectedStartDate;
		if(selectedStartDate)
			selectedStartDate = moment(this.selectedStartDate).utc().startOf('day').unix();

		this.downloadConsumptionsReportSubscription = this.adminService.createRequestForConsumptionsReport(this.selectedYear, this.selectedQuarter, this.selectedSiteId, selectedStartDate, this.siteName, regenerateFile).subscribe((res: any) => {
			if(res.url){
				this.downloadReport(res);
			} else this.getContent();
		});
	}

	getContent = async () => {
		const startTime = Date.now();
		const MAX_POLL_TIME = 4 * 60 * 1000;

		const pollFn = async() => {
			if(this.isPolling){ // Poll in process
				clearTimeout(this.RSDataTimer);
				this.RSDataTimer = setTimeout(pollFn, 20000);
				return;
			}

			if(Date.now() - startTime >= MAX_POLL_TIME){ // 4 minute max polling 
				clearTimeout(this.RSDataTimer);
				this.RSDataTimer = null;
				this.notificationMessage.setMessage('Error: There was an error in processing your file, please try again in a few minutes');
				return;
			}
			this.isPolling = true;
			const RSData: any = await this.adminService.getCompletedSRDocument(this.selectedSiteId).toPromise(); // CHeck if file has finshed
			this.isPolling = false;

			if(Object.keys(RSData).length === 0){// Still Processsing
				clearTimeout(this.RSDataTimer);
				this.RSDataTimer = null;
				this.RSDataTimer = setTimeout(pollFn, 20000);
				this.notificationMessage.setMessage('Your report is being processed, please wait, do not leave this page.', 'success');
			}else{ // Completed or Failed
				clearTimeout(this.RSDataTimer);
				this.RSDataTimer = null;
				if(RSData.err){
					switch (RSData.err) {
					case 'not_sr_site':
						this.notificationMessage.setMessage(this.translate.instant('site.not_sr_site'));
						break;
					case 'no_devices_founded':
						this.notificationMessage.setMessage(this.translate.instant('site.no_devices_founded'));
						break;
					case 'no_report_data':
						this.notificationMessage.setMessage(this.translate.instant('smart_rebates_reports.no_data'));
						break;
					case 'file_not_found':
						this.notificationMessage.setMessage(this.translate.instant('smart_rebates_reports.file_not_found'));
						break;
					default:
						break;
					}
				}else
					this.downloadReport(RSData)
			}
		};

		pollFn();
	}

	downloadReport(data: any) {
		if (!data || !data?.url) return;
		const a = document.createElement('a');
		a.href = data.url;
		a.download = 'Reports.zip'; // name the file on download
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
		clearTimeout(this.RSDataTimer);
		this.RSDataTimer = null;
	}

	ngOnDestroy() {
		if (this.downloadConsumptionsReportSubscription)
			this.downloadConsumptionsReportSubscription.unsubscribe();
		clearTimeout(this.RSDataTimer);
	}
}
